import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { useFocused } from "../hooks/useFocused";
import { colorNameMap } from "../../colorNameMap";
export const Circle = ({ x = 0, y = 0, radius, borderWidth = 1, borderTint, fillTint = 0, onmousedown, eventMode = onmousedown ? "static" : "none", }) => {
    const ref = useRef(null);
    const focused = useFocused(ref);
    return (_jsx("graphics", { ref: ref, onMouseDown: onmousedown, eventMode: eventMode, draw: (graphics) => {
            graphics.clear();
            graphics
                .circle(x, y, radius)
                .fill(fillTint)
                .stroke({ width: borderWidth, color: focused ? colorNameMap.white : borderTint });
        } }));
};
//# sourceMappingURL=Circle.js.map